// extracted by mini-css-extract-plugin
export default {"ratings":"style-module--ratings--C1ILj"};